module.exports = __webpack_public_path__ + "static/media/brego3593.ffb42d6a.jpg";